<template>
  <component :is="courseData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="courseData === undefined">
      <h4 class="alert-heading">Error fetching course data</h4>
      <div class="alert-body">
        No course found with this course id. Check
        <b-link class="alert-link" :to="{ name: 'apps-roster-course-list' }"> Course List </b-link>
        for other courses.
      </div>
    </b-alert>

    <b-tabs v-if="courseData" pills>
      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Information</span>
        </template>
        <course-edit-tab-information :course-data.sync="courseData" class="mt-2 pt-75" />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import rosterStoreModule from '../rosterStoreModule';
import CourseEditTabInformation from './CourseEditTabInformation.vue';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    CourseEditTabInformation,
  },
  setup() {
    const courseData = ref(null);

    const COURSE_APP_STORE_MODULE_NAME = 'app-roster';

    // Register module
    if (!store.hasModule(COURSE_APP_STORE_MODULE_NAME))
      store.registerModule(COURSE_APP_STORE_MODULE_NAME, rosterStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COURSE_APP_STORE_MODULE_NAME)) store.unregisterModule(COURSE_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch('app-roster/fetchCourse', { id: router.currentRoute.params.id })
      .then((response) => {
        courseData.value = response.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          courseData.value = undefined;
        }
      });

    return {
      courseData,
    };
  },
};
</script>

<style></style>
